// ============================================
// PART 1: Enhanced product-info.js
// ============================================

!(function () {
  "use strict";
  class t extends window.theme.DeferredMedia {
    constructor() {
      super();
    }
    loadContent() {
      super.loadContent(),
        Shopify.loadFeatures([
          {
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
    }
    setupModelViewerUI(t) {
      t ||
        (this.modelViewerUI = new Shopify.ModelViewerUI(
          this.querySelector("model-viewer")
        ));
    }
  }
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(t) {
      t ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ProductJSON-"]').forEach((t) => {
              window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", () =>
              this.setupShopifyXR()
            ));
    },
  }),
    window.addEventListener("DOMContentLoaded", () => {
      window.ProductModel && window.ProductModel.loadShopifyXR();
    }),
    customElements.get("product-info") ||
      customElements.define(
        "product-info",
        class extends HTMLElement {
          quantityInput = void 0;
          quantityForm = void 0;
          onVariantChangeUnsubscriber = void 0;
          cartUpdateUnsubscriber = void 0;
          abortController = void 0;
          pendingRequestUrl = null;
          preProcessHtmlCallbacks = [];
          postProcessHtmlCallbacks = [];
          currentVariant = null;
          constructor() {
            super(),
              (this.quantityInput = this.querySelector(
                "[data-quantity-input]"
              )),
              (this.productImages = this.querySelector("product-images")),
              (this.productMediaList = this.querySelector(
                "[data-product-media-list]"
              )),
              (this.variantImageScroll =
                "true" === this.getAttribute("data-variant-image-scroll")),
              (this.productFormWrapper = this.querySelector(
                "[data-form-wrapper]"
              )),
              (this.productForm = this.querySelector("product-form"));
          }
          connectedCallback() {
            this.initializeProductSwapUtility();
            try {
              const t = this.dataset.productHandle;
              window.Shopify?.Products?.recordRecentlyViewed &&
                (t
                  ? window.Shopify.Products.recordRecentlyViewed({ handle: t })
                  : window.Shopify.Products.recordRecentlyViewed());
            } catch (t) {
              console.warn("Recently viewed recording error:", t);
            }
            (this.onVariantChangeUnsubscriber = subscribe(
              theme.PUB_SUB_EVENTS.optionValueSelectionChange,
              this.handleOptionValueChange.bind(this)
            )),
              this.initQuantityHandlers(),
              this.initProductNotificationHandlers(),
              this.dispatchEvent(
                new CustomEvent("theme:product-info:loaded", { bubbles: !0 })
              ),
              (this.variantOptionImages = this.querySelectorAll(
                "[data-variant-option-image]"
              )),
              this.variantOptionImages.length > 1 && this.optionImagesWidth(),
              this.updatePreorderState(),
              this.checkLiveCartInfo(),
              (this.checkLiveCartInfoCallback = () => this.checkLiveCartInfo()),
              document.addEventListener(
                "theme:cart-drawer:close",
                this.checkLiveCartInfoCallback
              ),
              // NEW: Initialize on page load
              this.initializeVariantImageFilter();
          }
          // NEW: Initialize variant image filtering on page load
          initializeVariantImageFilter() {
            requestAnimationFrame(() => {
              const variant = this.getCurrentVariant();
              variant && this.filterImagesByVariant(variant);
            });
          }
          // NEW: Get current variant from page
          getCurrentVariant() {
            try {
              const variantInput = this.querySelector('input[name="id"]');
              if (variantInput && variantInput.value) {
                const productJson = this.querySelector("[data-product-json]");
                if (productJson) {
                  const product = JSON.parse(productJson.textContent);
                  return product.variants.find(
                    (v) => v.id == variantInput.value
                  );
                }
              }
            } catch (e) {
              console.warn("Error getting current variant:", e);
            }
            return null;
          }
          checkLiveCartInfo() {
            const t = this.productForm?.variantIdInput,
              e = t ? t.value : null;
            if (!e) return;
            const i = this.quantityInput
                ? parseInt(this.quantityInput.value, 10)
                : 1,
              r = `${theme.routes.root}products/${this.dataset.productHandle}?section_id=api-live-cart-info&variant=${e}`;
            fetch(r)
              .then((t) => t.text())
              .then((t) => {
                const e = new DOMParser().parseFromString(t, "text/html"),
                  r = Number(
                    e.querySelector("[data-item-count-for-variant]").innerHTML
                  ),
                  a = e.querySelector("[data-max-inventory]").innerHTML,
                  o = Number(a),
                  n = Boolean(i + r > o),
                  s = "" !== a && n,
                  u = "" !== a && r === o ? "form" : "cart",
                  d = this.querySelector("[data-product-form]");
                d &&
                  (d.setAttribute("data-max-inventory-reached", s),
                  d.setAttribute("data-error-message-position", u));
              })
              .catch((t) => {
                console.warn("Failed to check live cart info:", t);
              });
          }
          addPreProcessCallback(t) {
            this.preProcessHtmlCallbacks.push(t);
          }
          initQuantityHandlers() {
            this.quantityInput &&
              ((this.quantityForm = this.querySelector(
                ".product-form__quantity"
              )),
              this.quantityForm &&
                (this.setQuantityBoundaries(),
                this.quantityInput.addEventListener("change", () =>
                  this.updateButtonPrice()
                ),
                this.quantityInput.addEventListener("change", () =>
                  this.checkLiveCartInfo()
                ),
                this.dataset.originalSection ||
                  (this.cartUpdateUnsubscriber = subscribe(
                    theme.PUB_SUB_EVENTS.cartUpdate,
                    this.fetchQuantityRules.bind(this)
                  ))));
          }
          disconnectedCallback() {
            this.onVariantChangeUnsubscriber(),
              this.cartUpdateUnsubscriber?.(),
              document.removeEventListener(
                "theme:cart-drawer:close",
                this.checkLiveCartInfoCallback
              );
          }
          initializeProductSwapUtility() {
            this.postProcessHtmlCallbacks.push((t) => {
              window?.Shopify?.PaymentButton?.init(),
                window?.ProductModel?.loadShopifyXR(),
                this.optionImagesWidth(t);
            });
          }
          optionImagesWidth(t = this) {
            const e = t.querySelectorAll("[data-variant-option-image]");
            if (e.length > 1) {
              let t = 0;
              requestAnimationFrame(() => {
                e.forEach((e) => {
                  const i = e.clientWidth;
                  i > t && (t = i);
                }),
                  e.forEach((e) => {
                    const i = e.closest("[data-variant-buttons]");
                    i && i.style?.setProperty("--option-image-width", t + "px");
                  });
              });
            }
          }
          handleOptionValueChange({
            data: { event: t, target: e, selectedOptionValues: i },
          }) {
            if (!this.contains(t.target)) return;
            this.resetProductFormState();
            const r =
              e.dataset.productUrl ||
              this.pendingRequestUrl ||
              this.dataset.url;
            this.pendingRequestUrl = r;
            const a = this.dataset.url !== r,
              o = "true" === this.dataset.updateUrl && a;
            this.renderProductInfo({
              requestUrl: this.buildRequestUrlWithParams(r, i, o),
              targetId: e.id,
              callback: a
                ? this.handleSwapProduct(r, o)
                : this.handleUpdateProductInfo(r),
            });
          }
          resetProductFormState() {
            this.productForm?.toggleSubmitButton(!0);
          }
          handleSwapProduct(t, e) {
            return (i) => {
              this.productModal?.remove();
              const r = e ? "product-info[id^='MainProduct']" : "product-info",
                a = this.getSelectedVariant(i.querySelector(r));
              this.updateURL(t, a?.id),
                e
                  ? ((document.querySelector("head title").innerHTML =
                      i.querySelector("head title").innerHTML),
                    HTMLUpdateUtility.viewTransition(
                      document.querySelector("main"),
                      i.querySelector("main"),
                      this.preProcessHtmlCallbacks,
                      this.postProcessHtmlCallbacks
                    ))
                  : HTMLUpdateUtility.viewTransition(
                      this,
                      i.querySelector("product-info"),
                      this.preProcessHtmlCallbacks,
                      this.postProcessHtmlCallbacks
                    ),
                requestAnimationFrame(() => this.optionImagesWidth());
            };
          }
          renderProductInfo({ requestUrl: t, targetId: e, callback: i }) {
            this.abortController?.abort(),
              (this.abortController = new AbortController()),
              fetch(t, { signal: this.abortController.signal })
                .then((t) => t.text())
                .then((t) => {
                  this.pendingRequestUrl = null;
                  const e = new DOMParser().parseFromString(t, "text/html");
                  i(e);
                })
                .then(() => {
                  document.querySelector(`#${e}`)?.focus();
                })
                .catch((t) => {
                  "AbortError" === t.name
                    ? console.log("Fetch aborted by user")
                    : console.error(t);
                });
          }
          getSelectedVariant(t) {
            const e = t.querySelector(
              "variant-selects [data-selected-variant]"
            )?.innerHTML;
            return e ? JSON.parse(e) : null;
          }
          buildRequestUrlWithParams(t, e, i = !1) {
            const r = [];
            return (
              !i && r.push(`section_id=${this.sectionId}`),
              e.length && r.push(`option_values=${e.join(",")}`),
              `${t}?${r.join("&")}`
            );
          }
          updateOptionValues(t) {
            const e = t.querySelector("variant-selects");
            e &&
              HTMLUpdateUtility.viewTransition(
                this.variantSelectors,
                e,
                this.preProcessHtmlCallbacks
              );
          }
          showSoldoutNotificationButton(t) {
            this.productFormWrapper.classList.contains(
              "show-product-notification"
            ) &&
              (t
                ? this.productFormWrapper.classList.add("variant--soldout")
                : this.productFormWrapper.classList.remove("variant--soldout"));
          }
          updatePreorderState(t = this) {
            (this.submitButton = t.querySelector(
              `#ProductSubmitButton-${this.sectionId}`
            )),
              (this.isPreorder =
                "true" === this.submitButton?.dataset.preorder),
              (this.preorderInput = this.querySelector(
                "[data-product-preorder]"
              )),
              this.preorderInput &&
                (this.preorderInput.disabled = !this.isPreorder);
          }
          handleUpdateProductInfo(t) {
            return (e) => {
              const i = this.getSelectedVariant(e);
              if (
                (this.pickupAvailability?.update(i),
                this.updateOptionValues(e),
                this.updateURL(t, i?.id),
                this.updateVariantInputs(i?.id),
                !i)
              )
                return void this.setUnavailable();
              this.updatePreorderState(e);
              const r =
                !this.submitButton ||
                this.submitButton.hasAttribute("disabled");
              this.isPreorder && !r
                ? (this.productForm?.toggleSubmitButton(
                    !1,
                    window.theme.strings.preOrder
                  ),
                  this.showSoldoutNotificationButton(!1))
                : r
                ? (this.productForm?.toggleSubmitButton(
                    !0,
                    window.theme.strings.soldOut
                  ),
                  this.showSoldoutNotificationButton(!0))
                : (this.productForm?.toggleSubmitButton(
                    !1,
                    window.theme.strings.addToCart
                  ),
                  this.showSoldoutNotificationButton(!1)),
                // UPDATED: Filter BEFORE updateMedia
                this.filterImagesByVariant(i),
                this.updateMedia(i?.featured_media?.id);
              const a = (t, i = (t) => !1) => {
                const r = e.getElementById(`${t}-${this.sectionId}`),
                  a = this.querySelector(`#${t}-${this.dataset.section}`);
                r &&
                  a &&
                  ((a.innerHTML = r.innerHTML),
                  a.classList.toggle("hidden", i(r)));
              };
              a("Price"),
                a("Sku", ({ classList: t }) => t.contains("hidden")),
                a("Inventory"),
                a("Volume"),
                a("Price-Per-Item", ({ classList: t }) => t.contains("hidden")),
                a("CartBar"),
                a("Preorder"),
                a("Badges"),
                this.updateQuantityRules(this.sectionId, e),
                this.querySelector(
                  `#Quantity-Rules-${this.dataset.section}`
                )?.classList.remove("hidden"),
                this.querySelector(
                  `#Volume-Note-${this.dataset.section}`
                )?.classList.remove("hidden"),
                this.updateButtonPrice(),
                this.optionImagesWidth(),
                publish(theme.PUB_SUB_EVENTS.variantChange, {
                  data: { sectionId: this.sectionId, html: e, variant: i },
                });
            };
          }
          

// CORRECTED: Filter images method
filterImagesByVariant(variant) {
  if (!variant || !variant.title) {
    console.log("No variant provided to filter");
    return;
  }
  
  console.log("=== FILTERING IMAGES FOR VARIANT ===");
  console.log("Full variant title:", variant.title);
  
  const variantName = variant.title.split("/")[0].trim().toLowerCase();
  console.log("Extracted variant name:", variantName);
  
  const slides = this.productMediaList?.querySelectorAll("[data-slide]");
  console.log("Total slides found:", slides?.length);
  
  let visibleCount = 0;
  let hasVariantImages = false;
  let defaultImageCount = 0;
  let allVariantNames = new Set();
  let featuredMediaId = variant.featured_media?.id;
  
  console.log("Featured media ID:", featuredMediaId || 'not set');
  
  // First pass: analyze all slides
  slides?.forEach((slide, index) => {
    const slideVar = slide.getAttribute("var");
    const imageId = slide.getAttribute("data-image-id");
    const isFeatured = imageId && featuredMediaId && imageId == featuredMediaId;
    
    // Check if this is a default image (no var attribute OR var is null/empty)
    const isDefaultImage = !slideVar || slideVar === '' || slideVar === 'null' || slideVar === 'undefined';
    
    if (isDefaultImage) {
      defaultImageCount++;
      console.log(`  Slide ${index}: DEFAULT/FEATURED image`);
    } else {
      const slideVarLower = slideVar.toLowerCase().trim();
      allVariantNames.add(slideVarLower);
      
      if (slideVarLower === variantName) {
        hasVariantImages = true;
        console.log(`  Slide ${index}: ✓ Matches variant "${variantName}"`);
      } else {
        console.log(`  Slide ${index}: var="${slideVar}" (different variant)`);
      }
    }
  });
  
  console.log("Summary:");
  console.log("  - Has variant-specific images:", hasVariantImages);
  console.log("  - Default/featured images count:", defaultImageCount);
  console.log("  - All variant names found:", Array.from(allVariantNames));
  
  // Determine strategy
  let strategy = '';
  let targetVariant = null;
  
  if (hasVariantImages) {
    strategy = 'show-variant-images';
    targetVariant = variantName;
    console.log("→ STRATEGY: Show variant-specific images only");
  } else if (defaultImageCount > 0) {
    strategy = 'show-defaults';
    console.log("→ STRATEGY: Show default/featured images (variant has no images)");
  } else if (allVariantNames.size > 0) {
    strategy = 'show-fallback';
    targetVariant = Array.from(allVariantNames)[0];
    console.log("→ STRATEGY: Show fallback variant images:", targetVariant);
  } else {
    strategy = 'show-all';
    console.log("→ STRATEGY: Show all images (fallback)");
  }
  
  // Second pass: show/hide slides based on strategy
  slides?.forEach((slide, index) => {
    const slideVar = slide.getAttribute("var");
    const imageId = slide.getAttribute("data-image-id");
    const isDefaultImage = !slideVar || slideVar === '' || slideVar === 'null' || slideVar === 'undefined';
    const isFeatured = imageId && featuredMediaId && imageId == featuredMediaId;
    
    let shouldShow = false;
    
    switch(strategy) {
      case 'show-variant-images':
        // Only show images matching the current variant
        if (!isDefaultImage) {
          const slideVarLower = slideVar.toLowerCase().trim();
          shouldShow = slideVarLower === variantName;
        }
        break;
        
      case 'show-defaults':
        // Only show default/featured images (Slide 0 with var=null)
        shouldShow = isDefaultImage;
        break;
        
      case 'show-fallback':
        // Only show images matching fallback variant
        if (!isDefaultImage) {
          const slideVarLower = slideVar.toLowerCase().trim();
          shouldShow = slideVarLower === targetVariant;
        }
        break;
        
      case 'show-all':
        // Show all images
        shouldShow = true;
        break;
    }
    
    console.log(`  Slide ${index} (var="${slideVar || 'null'}"): ${shouldShow ? 'SHOW' : 'HIDE'}`);
    
    if (shouldShow) {
      visibleCount++;
      slide.classList.remove("hidden", "media--hidden", "media--hiding");
      slide.style.display = "";
      slide.removeAttribute("hidden");
    } else {
      slide.classList.add("hidden", "media--hidden");
      slide.classList.remove("media--active");
      slide.style.display = "none";
    }
  });
  
  console.log("✓ Visible slides after filter:", visibleCount);
  
  // Safety check - if nothing visible, show first slide
  if (visibleCount === 0 && slides?.length > 0) {
    console.warn("⚠ SAFETY: Nothing visible! Showing first slide...");
    const firstSlide = slides[0];
    firstSlide.classList.remove("hidden", "media--hidden", "media--hiding");
    firstSlide.style.display = "";
    firstSlide.removeAttribute("hidden");
    visibleCount = 1;
  }
  
  // Update thumbnails
  const productThumbs = this.querySelector("product-thumbs");
  if (productThumbs) {
    productThumbs.updateThumbsForVariant(variantName, strategy, targetVariant, featuredMediaId);
  }
  
  requestAnimationFrame(() => {
    this.setFirstVisibleSlideActive();
  });
  
  console.log("=== END FILTERING ===\n");
}
          // NEW: Set first visible slide as active
          setFirstVisibleSlideActive() {
            const visibleSlide = this.productMediaList?.querySelector(
              "[data-slide]:not(.hidden):not([style*='display: none'])"
            );
            console.log("First visible slide:", visibleSlide);
            if (visibleSlide) {
              const mediaId = visibleSlide.getAttribute("data-media-id");
              console.log("Setting active media ID:", mediaId);
              if (mediaId) {
                this.productImages?.setAttribute("data-active-media", mediaId);
                this.productMediaList
                  ?.querySelectorAll("[data-slide]")
                  .forEach((slide) => {
                    slide.classList.remove("media--active");
                  });
                visibleSlide.classList.add("media--active");
                const productThumbs = this.querySelector("product-thumbs");
                const matchingThumb = productThumbs?.querySelector(
                  `[data-media-id="${mediaId}"]`
                );
                if (matchingThumb) {
                  productThumbs
                    ?.querySelectorAll("[data-thumb-item]")
                    .forEach((t) => t.classList.remove("is-active"));
                  matchingThumb
                    .closest("[data-thumb-item]")
                    ?.classList.add("is-active");
                }
              }
            } else {
              console.warn("No visible slides found after filtering!");
            }
          }
          updateVariantInputs(t) {
            this.querySelectorAll(
              `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
            ).forEach((e) => {
              const i = e.querySelector('input[name="id"]');
              (i.value = t ?? ""),
                i.dispatchEvent(new Event("change", { bubbles: !0 }));
            });
          }
          updateURL(t, e) {
            this.querySelector("share-button")?.updateUrl(
              `${window.theme.routes.shop_url}${t}${e ? `?variant=${e}` : ""}`
            ),
              "false" !== this.dataset.updateUrl &&
                window.history.replaceState(
                  {},
                  "",
                  `${t}${e ? `?variant=${e}` : ""}`
                );
          }
          setUnavailable() {
            this.productForm?.toggleSubmitButton(
              !0,
              window.theme.strings.unavailable
            ),
              this.showSoldoutNotificationButton(!1);
            const t = [
              "price",
              "Inventory",
              "Sku",
              "Price-Per-Item",
              "Volume-Note",
              "Volume",
              "Quantity-Rules",
            ]
              .map((t) => `#${t}-${this.dataset.section}`)
              .join(", ");
            document
              .querySelectorAll(t)
              .forEach(({ classList: t }) => t.add("hidden"));
          }
          
updateMedia(mediaId) {
  if (!mediaId) {
    console.log("No featured media ID, using first visible slide");
    this.setFirstVisibleSlideActive();
    return;
  }
  
  const selectedImage = this.querySelector(`[data-image-id="${mediaId}"]:not(.hidden):not([style*='display: none'])`);
  
  if (!selectedImage) {
    console.log("Featured media not found or hidden, using first visible");
    this.setFirstVisibleSlideActive();
    return;
  }
  
  const selectedImageId = selectedImage.getAttribute("data-media-id");
  const isDesktopView = !window.theme.isMobile();
  
  selectedImage.dispatchEvent(
    new CustomEvent('theme:media:select', {
      bubbles: true,
      detail: {
        id: selectedImageId,
      },
    })
  );
  
  requestAnimationFrame(() => {
    // Desktop scroll behavior
    if (isDesktopView && !this.productImages.hasAttribute("data-fader-desktop") && this.variantImageScroll) {
      const selectedImageTop = selectedImage.getBoundingClientRect().top;
      
      document.dispatchEvent(
        new CustomEvent('theme:tooltip:close', {
          bubbles: false,
          detail: {
            hideTransition: false,
          },
        })
      );
      
      window.theme.scrollTo(selectedImageTop);
    }
    
    // Mobile scroll behavior
    if (!isDesktopView && !this.productImages.hasAttribute("data-fader-mobile")) {
      this.productMediaList.scrollTo({
        left: selectedImage.offsetLeft,
      });
    }
  });
}
          setQuantityBoundaries() {
            const t = {
              cartQuantity: this.quantityInput.dataset.cartQuantity
                ? parseInt(this.quantityInput.dataset.cartQuantity)
                : 0,
              min: this.quantityInput.dataset.min
                ? parseInt(this.quantityInput.dataset.min)
                : 1,
              max: this.quantityInput.dataset.max
                ? parseInt(this.quantityInput.dataset.max)
                : null,
              step: this.quantityInput.step
                ? parseInt(this.quantityInput.step)
                : 1,
            };
            let e = t.min;
            const i = null === t.max ? t.max : t.max - t.cartQuantity;
            null !== i && (e = Math.min(e, i)),
              t.cartQuantity >= t.min && (e = Math.min(e, t.step)),
              (this.quantityInput.min = e),
              i
                ? (this.quantityInput.max = i)
                : this.quantityInput.removeAttribute("max"),
              (this.quantityInput.value = e),
              publish(theme.PUB_SUB_EVENTS.quantityUpdate, void 0),
              this.updateButtonPrice();
          }
          fetchQuantityRules() {
            const t = this.productForm?.variantIdInput?.value;
            if (t)
              return (
                this.querySelector(
                  ".quantity__rules-cart .loading__spinner"
                ).classList.remove("hidden"),
                fetch(
                  `${this.dataset.url}?variant=${t}&section_id=${this.dataset.section}`
                )
                  .then((t) => t.text())
                  .then((t) => {
                    const e = new DOMParser().parseFromString(t, "text/html");
                    this.updateQuantityRules(this.dataset.section, e);
                  })
                  .catch((t) => {
                    console.warn("Failed to fetch quantity rules:", t);
                  })
                  .finally(() => {
                    this.querySelector(
                      ".quantity__rules-cart .loading__spinner"
                    )?.classList.add("hidden");
                  })
              );
          }
          updateQuantityRules(t, e) {
            if (!this.quantityInput) return;
            this.setQuantityBoundaries();
            const i = e.getElementById(`Quantity-Form-${t}`),
              r = [
                "[data-quantity-input]",
                "[data-quantity-rules]",
                "[data-quantity-label]",
              ];
            for (let t of r) {
              const e = this.quantityForm.querySelector(t),
                r = i.querySelector(t);
              if (e && r)
                if ("[data-quantity-input]" === t) {
                  const t = [
                    "data-cart-quantity",
                    "data-min",
                    "data-max",
                    "step",
                  ];
                  for (let i of t) {
                    const t = r.getAttribute(i);
                    null !== t ? e.setAttribute(i, t) : e.removeAttribute(i);
                  }
                } else e.innerHTML = r.innerHTML;
            }
            this.updateButtonPrice();
          }
          updateButtonPrice() {
            const t = this.querySelector("[data-product-price]");
            if (!t) return;
            const e = this.getSelectedVariant(this) || null;
            if (!e) return;
            const i =
                (this.quantityInput &&
                  parseInt(this.quantityInput.value || "1", 10)) ||
                1,
              r = e.price || 0,
              a = e.compare_at_price || 0,
              o = r * i,
              n = a > r ? a * i : 0,
              s =
                0 === o
                  ? window.theme.strings.free
                  : window.theme.formatMoney(o, theme.moneyFormat);
            let u = s;
            if (n) {
              u = `${s} <s>${window.theme.formatMoney(
                n,
                theme.moneyFormat
              )}</s>`;
            }
            t.innerHTML = u;
          }
          initProductNotificationHandlers() {
            const t = this.querySelector("product-notification");
            if (!t) return;
            const e = t
              .closest("popup-component")
              ?.querySelector("[data-popup-open]");
            this.querySelectorAll("[data-notification-popup-button]")?.forEach(
              (t) => {
                t.addEventListener("click", (t) => {
                  t.preventDefault(), e.dispatchEvent(new Event("click"));
                });
              }
            );
          }
          get productModal() {
            return document.querySelector(
              `#ProductModal-${this.dataset.section}`
            );
          }
          get pickupAvailability() {
            return this.querySelector("pickup-availability");
          }
          get variantSelectors() {
            return this.querySelector("variant-selects");
          }
          get relatedProducts() {
            const t = SectionId.getIdForSection(
              SectionId.parseId(this.sectionId),
              "related-products"
            );
            return document.querySelector(
              `product-recommendations[data-section-id^="${t}"]`
            );
          }
          get quickOrderList() {
            const t = SectionId.getIdForSection(
              SectionId.parseId(this.sectionId),
              "quick_order_list"
            );
            return document.querySelector(`quick-order-list[data-id^="${t}"]`);
          }
          get sectionId() {
            return this.dataset.originalSection || this.dataset.section;
          }
        }
      ),
    customElements.get("product-model") ||
      customElements.define("product-model", t);
})();
